import type { SenderFilterMode } from 'constants/FilterConstants';

import type { Action } from 'modules/global/generic.types';
import * as actionTypes from 'modules/interventions/actionTypes';

import type * as types from '../types/actions';

type InterventionFilterField = keyof import('../reducers/ui/filters').InterventionFilterReducer;
type KanbanFilterField = import('../reducers/ui/kanban/filters').FilterField;
type MobilityFilterField = import('../reducers/ui/mobility/filters').FilterField;

// INTERVENTIONS FILTERS
export const setInterventionsFilter = (
  field: InterventionFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): Action<{ field: InterventionFilterField; value: unknown }> => ({
  type: actionTypes.SET_INTERVENTIONS_FILTERS,
  payload: { field, value },
  meta,
});

export const removeFilter = (
  field: InterventionFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): Action<{ field: InterventionFilterField; value: unknown }> => ({
  type: actionTypes.REMOVE_INTERVENTION_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

export const clearInterventionsFilters = (): Action<undefined> => ({
  type: actionTypes.CLEAR_INTERVENTIONS_FILTERS,
});

export const clearInterventionsTemporaryFilters = (): Action<undefined> => ({
  type: actionTypes.CLEAR_INTERVENTIONS_TEMPORARY_FILTERS,
});

export const toggleQuickFilter = (field: string): Action<string> => ({
  type: actionTypes.TOGGLE_QUICK_FILTER,
  payload: field,
});

export const setInterventionsSenderFilterMode = (mode: SenderFilterMode): Action<SenderFilterMode> => ({
  type: actionTypes.SET_INTERVENTIONS_SENDER_FILTER_MODE,
  payload: mode,
});

// KANBAN FILTERS
export const setKanbanFilter = (
  field: KanbanFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): types.SetKanbanFilterAction => ({
  type: actionTypes.SET_KANBAN_INTERVENTION_FILTER,
  payload: { field, value },
  meta,
});

export const setKanbanFilters = (
  filters: { field: KanbanFilterField; value: unknown }[],
  meta: Record<string, unknown> = {},
): types.SetKanbanFiltersAction => ({
  type: actionTypes.SET_KANBAN_INTERVENTION_FILTERS,
  payload: filters,
  meta,
});

export const removeKanbanFilter = (
  field: KanbanFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): Action<{ field: KanbanFilterField; value: unknown }> => ({
  type: actionTypes.REMOVE_KANBAN_INTERVENTION_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

export const clearKanbanFilters = (
  payload?: undefined,
  meta: Record<string, unknown> = {},
): types.ClearKanbanFiltersAction => ({
  type: actionTypes.CLEAR_KANBAN_INTERVENTION_FILTER,
  payload,
  meta,
});

export const setKanbanSenderFilterMode = (mode: SenderFilterMode): Action<SenderFilterMode> => ({
  type: actionTypes.SET_KANBAN_SENDER_FILTER_MODE,
  payload: mode,
});

// MOBILITY FILTERS
export const setMobilityFilter = (
  field: MobilityFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): Action<{ field: MobilityFilterField; value: unknown }> => ({
  type: actionTypes.SET_MOBILITY_INTERVENTION_FILTER,
  payload: { field, value },
  meta,
});

export const setMobilityFilters = (
  filters: { field: MobilityFilterField; value: unknown }[],
  meta: Record<string, unknown> = {},
): Action<{ field: MobilityFilterField; value: unknown }[]> => ({
  type: actionTypes.SET_MOBILITY_INTERVENTION_FILTERS,
  payload: filters,
  meta,
});

export const removeMobilityFilter = (
  field: MobilityFilterField,
  value: unknown,
  meta: Record<string, unknown> = {},
): Action<{ field: MobilityFilterField; value: unknown }> => ({
  type: actionTypes.REMOVE_MOBILITY_INTERVENTION_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

export const clearMobilityFilters = (
  payload?: undefined,
  meta: Record<string, unknown> = {},
): Action<undefined> => ({
  type: actionTypes.CLEAR_MOBILITY_INTERVENTION_FILTER,
  payload,
  meta,
});
